export default __webpack_public_path__ + "static/techguru-example4-35bdc35acd53d3795edf6e75b8f9395b.jpg";